import React from 'react';
import {connect} from 'react-redux';
import {injectIntl, defineMessages} from 'react-intl';

const messages = defineMessages({
    exploreTitle: {
        id: 'banner.explore.title',
        defaultMessage: 'UNTRANSLATED'
    },
    exploreText: {
        id: 'banner.explore.text',
        defaultMessage: 'UNTRANSLATED'
    },

    bookTitle: {
        id: 'banner.book.title',
        defaultMessage: 'UNTRANSLATED'
    },
    bookText: {
        id: 'banner.book.text',
        defaultMessage: 'UNTRANSLATED'
    },

    enjoyTitle: {
        id: 'banner.enjoy.title',
        defaultMessage: 'UNTRANSLATED'
    },
    enjoyText: {
        id: 'banner.enjoy.text',
        defaultMessage: 'UNTRANSLATED'
    },

    contactTitle: {
        id: 'banner.contact.title',
        defaultMessage: 'UNTRANSLATED'
    },
    contactText: {
        id: 'banner.contact.text',
        defaultMessage: 'UNTRANSLATED'
    },

    searchTitle: {
        id: 'banner.search.title',
        defaultMessage: 'UNTRANSLATED'
    },
    searchText: {
        id: 'banner.search.text',
        defaultMessage: 'UNTRANSLATED'
    }
});

export const BannerItemComponent = ({
    type,
    brandName,
    intl: {formatMessage}
}) => (
    <article className="banner-item">
        <header>
            <span className={`banner-icon banner-icon-${type}`} />
            <h2>{formatMessage(messages[`${type}Title`])}</h2>
        </header>
        <p>{formatMessage(messages[`${type}Text`], {brandName})}</p>
    </article>
);

function mapStateToProps(state) {
    return {
        brandName: state.config.site.brandName
    };
}

export const BannerItem = injectIntl(
    connect(mapStateToProps)(BannerItemComponent)
);
export default BannerItem;
